import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import gul from '../img/GUL MAKAI.jpg';
import kashi from '../img/KASHI.jpg';
import cinema from '../img/CINEMA ZINDABAD.jpg';
import saaya from '../img/SAAYA.jpg';
import romeo from '../img/ROMEO AND RADHIKA.jpg';
import nawabzaade from '../img/NAWABZAADE.jpeg';
import ratanpur from '../img/RATANPUR.jpg';
import singham from '../img/SINGHAM.jpg';
import cif from '../img/CIF.png';
import cif2 from '../img/CIF2.jpg';
import khwaabon from '../img/KHWAABON KI ZAMINPAR.jpg';
import chandrakanta from '../img/CHANDRAKANTA.avif';
import ekghar from '../img/EK GHAR BANAUNGA.png';
import gusthak from '../img/GUSTHAK DIL.jpg';
import rajkumar from '../img/RAJKUMAR AARYAN.jpg';
import balika from '../img/BALIKA VADHU.jpg';
import shaurya from '../img/SHAURYA SUHANI.jpg';
import jyoti from '../img/JYOTI.jpg';
import naamkaran from '../img/NAAMKARAN.jpg';
import maniben from '../img/MANIBEN.COM.jpg';
import lalishq from '../img/LAL ISHQ.jpg';
import savdhanindia from '../img/SAVDHAN INDIA.jpg';
import meresai from '../img/MERE SAI.jpg'
import ahilya from '../img/AHILYA.webp';
import ahilya2 from '../img/AHILYA2.jpg';
import ahilya3 from '../img/AHILYA3.jpg';
import saavi from '../img/SAAVI KI SAVAARI.jpg';
import saavi2 from '../img/SAAVI KI SAVAARI 2.jpg';
import saavi3 from '../img/SAAVI KI SAVAARI3.jpg';
import campusbeast from '../img/CAMPUS BEATS.jpg';

const Carousel = () => {
  const movies = [
    gul, kashi, cinema, saaya, romeo, nawabzaade, ratanpur, singham, cif, cif2,
    khwaabon, chandrakanta, ekghar, gusthak, rajkumar, balika, shaurya, jyoti,
    naamkaran, maniben, lalishq, savdhanindia,meresai, ahilya, ahilya2, ahilya3, saavi,
    saavi2, saavi3, campusbeast,
  ];

  const [index, setIndex] = useState(0);
  const [postersPerView, setPostersPerView] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setPostersPerView(1); // Mobile devices
      } else if (window.innerWidth <= 768) {
        setPostersPerView(2); // Tablets
      } else {
        setPostersPerView(3); // Desktops
      }
    };


    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const nextSlide = () => {
    if (index < movies.length - postersPerView) setIndex(index + 1);
  };

  const prevSlide = () => {
    if (index > 0) setIndex(index - 1);
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <div className="carousel-container">
      <button onClick={prevSlide} className="carousel-button">
        <i className="fa-solid fa-chevron-left"></i>
      </button>
      <div className="carousel-wrapper" style={{ overflow: 'hidden' }}>
        <div
          className="carousel-track"
          style={{
            display: 'flex',
            transform: `translateX(-${(index * 100) / postersPerView}%)`,
            transition: 'transform 0.3s ease',
          }}
        >
          {movies.map((movie, idx) => (
            <motion.div
              key={idx}
              className="carousel-item"
              initial="hidden"
              animate="visible"
              variants={itemVariants}
              transition={{ duration: 0.5 }}
              style={{ flex: `0 0 ${100 / postersPerView}%` }}
            >
              <img src={movie} alt={`Movie ${idx + 1}`} />
            </motion.div>
          ))}
        </div>
      </div>
      <button onClick={nextSlide} className="carousel-button">
        <i className="fa-solid fa-chevron-right"></i>
      </button>
    </div>
  );
};

export default Carousel;
